import { FC, Fragment } from 'react';
import { useTranslation } from 'utils/i18n';

interface Props {
  wrapper?: boolean;
  className?: string;
  message?: string;
}

const NoScriptWarning: FC<Props> = ({
  wrapper = true,
  className = 'no-script-warning',
  message,
}) => {
  const { t } = useTranslation('common');
  const defaultMessage = message || t('noscript_warning');
  const Wrapper = wrapper ? 'noscript' : Fragment;

  return (
    <Wrapper>
      <div className={className}>{defaultMessage}</div>
    </Wrapper>
  );
};

export default NoScriptWarning;
